import { Box, useMediaQuery } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { Link } from 'react-router-dom';

import FaqIcon from 'common/shared-ui/src/icons/FaqIcon';
import NotificationIcon from 'common/shared-ui/src/icons/NotificationIcon';

// Original class: HeaderIconsRoot
const StyledHeaderIconsRoot = styled(Box)(({ theme }) => ({
  marginLeft: '32px',
  marginRight: theme.spacing(8),

  [theme.breakpoints.down('sm')]: {
    marginRight: 0,
  },
}));
// Original class: icon
const StyledIcon = styled(Link, {
  shouldForwardProp: prop => !['notificationIconStyle'].includes(prop),
})(({ theme, notificationIconStyle }) => ({
  width: 32,
  height: 32,
  padding: theme.spacing(1),
  '& svg': {
    fill: '#fff',
    width: '100%',
    height: '100%',
  },
  ...(notificationIconStyle && {
    marginRight: theme.spacing(2),

    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
    },
  }),
}));

const HeaderNavIcons = () => {
  const isSmallScreen = useMediaQuery(theme =>
    theme.breakpoints.maxWidth('sm'),
  );

  const config = window.APP_CONFIG;

  const shouldDisplayHelpLink = config.features.HELP_LINK && !isSmallScreen;

  return (
    <StyledHeaderIconsRoot
      sx={{
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'center',
      }}
    >
      <StyledIcon to='/' notificationIconStyle={true}>
        <NotificationIcon viewBox='0 0 24 24' />
      </StyledIcon>
      {shouldDisplayHelpLink && (
        <StyledIcon target={'_blank'} to={config.env.XWIKI_HOST}>
          <FaqIcon viewBox='0 0 24 24' />
        </StyledIcon>
      )}
    </StyledHeaderIconsRoot>
  );
};

export default HeaderNavIcons;
